<template>
  <v-container>
    <v-card class="mx-auto rounded-xl">
      <v-row justify="center">
        <v-col cols="12">
          <v-card class="pa-4" elevation="4">
            <v-card-title>
              {{ isEditing ? 'Editar Video' : 'Novo Video' }}
            </v-card-title>
            <v-card-text>

              <v-tabs v-model="currentTab" dark class="mb-18">
                <v-tab value="details">Detalhes</v-tab>
              </v-tabs>

              <v-form ref="formRef" @submit.prevent="handleSubmit">
                <v-window v-model="currentTab" class="mt-2">
                  <v-window-item value="details">
                    <v-row class="mt-2">
                      <v-col cols="6">
                        <v-text-field v-model="formValue.title" label="Titulo" :rules="[rules.title]"></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field v-model="formValue.description" label="Descrição"></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field v-model="formValue.video_url" label="URL do video"
                          :rules="[rules.url]"></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6" md="3">
                        <v-switch v-model="formValue.is_active" color="success" label="Video Ativo?"></v-switch>
                      </v-col>

                      <v-col cols="12" sm="6" md="3">
                        <v-select v-model="formValue.type" :items="videoTypes" label="Tipo de Video" item-title="label"
                          item-value="value" :rules="[rules.required]"></v-select>
                      </v-col>
                    </v-row>
                  </v-window-item>
                </v-window>
              </v-form>
            </v-card-text>

            <v-card-actions class="d-flex justify-space-between">
              <v-btn color="secondary" variant="flat" @click="handleCancel">
                <v-icon left>mdi-arrow-left</v-icon>
                Voltar
              </v-btn>
              <v-btn color="primary" variant="flat" :loading="isSubmitting" :disabled="isSubmitting"
                @click="handleSubmit">
                <v-icon left>mdi-content-save</v-icon>
                {{ isEditing ? 'Salvar Alterações' : 'Cadastrar Video' }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import api from '@/services/api';
import { useToastStore } from '@/store/toast';
import { useLoadingOverlay } from '@/store/loadingOverlay';

const toastStore = useToastStore();
const loadingOverlay = useLoadingOverlay();
const route = useRoute();
const router = useRouter();
const formRef = ref(null);

const currentTab = ref('details');
const isSubmitting = ref(false);

const formValue = ref({
  title: '',
  description: '',
  video_url: '',
  type: 'internal',
  is_active: true,
});

const isEditing = computed(() => !!route.params.id);

const videoTypes = [
  { label: 'Interno', value: 'internal' },
  { label: 'Externo', value: 'external' },
];

const rules = {
  title: v => !!v || 'O título é obrigatório.',
  url: v => !!v || 'A url do video é obrigatório.',
};

const loadVideo = async (id) => {
  loadingOverlay.startLoading();
  try {
    const response = await api.get(`/videos/${id}`);
    const data = response.data.data;

    if (data) {
      formValue.value = {
        title: data.title,
        description: data.description,
        video_url: data.video_url,
        type: data.type,
        is_active: data.is_active === 1,
      };
    } else {
      toastStore.showToast({ message: 'O video não foi encontrado.', color: 'warning' });
    }

  } catch (error) {
    console.error('Erro ao carregar os dados do video:', error);
    toastStore.showToast({
      message: error?.response?.data?.error || 'Erro ao carregar os dados do video',
      color: 'error',
    });
  } finally {
    loadingOverlay.stopLoading();
  }
};

const handleSubmit = async () => {
  const { valid } = await formRef.value.validate();
  if (!valid) {
    currentTab.value = 'details';
    return;
  }

  isSubmitting.value = true;

  const payload = { ...formValue.value };
  payload.is_active = payload.is_active ? 1 : 0;

  try {
    if (isEditing.value) {
      await api.put(`/videos/${route.params.id}`, payload);
    } else {
      await api.post('/videos', payload);
    }

    router.push('/app/videos');
    toastStore.showToast({
      message: isEditing.value ? 'Video atualizado com sucesso!' : 'Video cadastrado com sucesso!',
      color: 'success',
    });

  } catch (error) {
    console.error('Erro ao salvar video:', error);
    toastStore.showToast({
      message: error?.response?.data?.error || 'Erro ao salvar video',
      color: 'error',
    });
  } finally {
    isSubmitting.value = false;
  }
};

const handleCancel = () => {
  router.push('/app/videos');
};

onMounted(() => {
  if (isEditing.value) {
    loadVideo(route.params.id);
  }
});
</script>
